<template>
  <div id="BiddingDetailComponent" class="layout-bidding-all">
    <v-card outlined
      ><v-card-title>Bidding Detail</v-card-title
      ><v-card-text
        ><v-row class="pa-6"
          ><v-col cols="12"
            ><p class="text--primary subtitle-2">Subject</p>
            <p>{{ dataProjectInfo.subject }}</p></v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Project Code</p>
            <v-chip v-if="dataProjectInfo.projectCode != null">{{
              dataProjectInfo.projectCode
            }}</v-chip> </v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Project Status</p>
            <v-chip
              dark
              :color="
                setChipStatusColor(
                  dataProjectInfo.projectStatus,
                  dataProjectInfo.vendorProjectStatus
                )
              "
              >{{ dataProjectInfo.vendorProjectStatus }}</v-chip
            > </v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Bidding Status</p>
            <v-chip
              :color="setChipBiddingStatusColor(dataProjectInfo.biddingStatus)"
              >{{
                dataProjectInfo.biddingStatus != null
                  ? dataProjectInfo.biddingStatus
                  : "Not Start"
              }}</v-chip
            > </v-col
          ><v-col cols="12" class="mt-4"
            ><p class="text--primary subtitle-2">Description</p>
            <p>{{ dataProjectInfo.projectDescription }}</p></v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Bidding Start Date</p>
            <v-chip>{{ format(dataProjectInfo.startDate) }}</v-chip> </v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Bidding End Date</p>
            <v-chip> {{ format(dataProjectInfo.endDate) }}</v-chip> </v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Purchaser</p>
            <p>{{ dataProjectInfo.purchaser }}</p></v-col
          ><v-col cols="3"
            ><p class="text--primary subtitle-2">Contact Number</p>
            <p>{{ dataProjectInfo.contactNumber }}</p></v-col
          ></v-row
        ></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { dateFormat } from "../../../services/utility";
export default {
  name: "BiddingDetailComponent",
  data: () => ({
    dataProjectInfo: {},
  }),
  async mounted() {
    this.getProjectDetail();
  },

  methods: {
    async getProjectDetail() {
      var result = await _projectservice.GetProjectBiddingDetail(
        this.$route.params.projectId,
        this.$store.state.AppActiveUser.vendorID
      );
      if (result.length == 0)
        result = await _projectservice.GetPublicBiddingDetail(
          this.$route.params.projectId
        );
      const filterByRound = result.sort(
        (a, b) =>
          (a.biddingRound === null) - (b.biddingRound === null) ||
          +(a.biddingRound > b.biddingRound) ||
          -(a.biddingRound < b.biddingRound)
      );
      this.dataProjectInfo = filterByRound[result.length - 1];
      this.callBackToMain();
    },
    callBackToMain() {
      this.$emit("emitProjectDetail", this.dataProjectInfo);
    },
    format(date) {
      return dateFormat(date);
    },
    setChipStatusColor(status, vendor) {
      let color = "";
      if (vendor == "Open") color = "#2980B9";
      if (vendor == "On Process") color = "warning";
      if (vendor == "Re-Open") color = "#8E44AD";
      if (vendor == "Award") color = "#3498DB";
      if (vendor == "Complete") color = "secondary";

      return color;
    },
    setChipBiddingStatusColor(status) {
      console.log("status", status);
      let color = "";
      if (status == "Not Start") color = "primary";
      if (status == "Draft") color = "warning";
      if (status == "Submitted") color = "secondary";

      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
</style>
